import React, { useState, useEffect } from "react";
import { useParams } from "react-router-dom";
import axiosInstance from "../../../utils/axiosInstance";
import { Box, Paper, Typography, Grid } from "@mui/material";

export default function FactStats({ refresh }) {
    const { chatbotId } = useParams();
    const [stats, setStats] = useState(null);

    useEffect(() => {
        fetchStats();
    }, [chatbotId, refresh]);

    const fetchStats = async () => {
        try {
            const response = await axiosInstance.get('/api/facts/stats', {
                params: { chatbot_id: chatbotId }
            });
            if (response.data.success) {
                setStats(response.data.data);
            }
        } catch (error) {
            console.error('Error fetching fact stats:', error);
        }
    };

    if (!stats) return null;

    const statCards = [
        { label: 'Total Facts', value: stats.total_facts, color: '#3b82f6' },
        { label: 'Active', value: stats.active_facts, color: '#22c55e' },
        { label: 'Expired', value: stats.expired_facts, color: '#ef4444' },
        { label: 'Pending Review', value: stats.pending_review, color: '#f59e0b' },
        { label: 'Unique Entities', value: stats.unique_entities, color: '#8b5cf6' },
        { label: 'Relationships', value: stats.total_relationships, color: '#06b6d4' },
    ];

    return (
        <Grid container spacing={2} sx={{ mb: 3 }}>
            {statCards.map((card, index) => (
                <Grid item xs={6} sm={4} md={2} key={index}>
                    <Paper
                        elevation={0}
                        sx={{
                            p: 2,
                            textAlign: 'center',
                            borderRadius: 2,
                            border: '1px solid',
                            borderColor: 'divider',
                            bgcolor: 'background.paper',
                        }}
                    >
                        <Typography variant="h4" sx={{ color: card.color, fontWeight: 700, mb: 0.5 }}>
                            {card.value}
                        </Typography>
                        <Typography variant="caption" color="text.secondary" sx={{ fontSize: '0.75rem' }}>
                            {card.label}
                        </Typography>
                    </Paper>
                </Grid>
            ))}
        </Grid>
    );
}
